import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelect } from 'downshift';
import Button from 'react-bootstrap/Button';
import styles from './share-class-dropdown.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const DropdownShareClass = ({ items = [], selectedItem }) => {
  const triggerRef = useRef();

  const {
    getLabelProps,
    getToggleButtonProps,
    getMenuProps,
    getItemProps,
    isOpen,
    highlightedIndex
  } = useSelect({
    items,
    selectedItem,
    itemToString: i => i.label
  });

  return (
    <span {...className('dropdown', 'd-none', 'd-sm-block')}>
      <label {...className('sr-only')} {...getLabelProps()} aria-label={getLabelProps()?.id} />
      <Button
        ref={triggerRef}
        variant="share-class-dropdown-trigger"
        {...className('dropdown_toggle', 'font-weight-medium', 'bg-primary')}
        {...getToggleButtonProps()}
        aria-label={getLabelProps()?.id}
      >
        {selectedItem.name}
      </Button>
      {
        <ul
          {...className('dropdown_items', isOpen ? '' : 'd-none')}
          {...getMenuProps({ refKey: triggerRef.current })}
        >
          {items.map((item, index) => (
            <li
              {...className(
                'font-weight-bold',
                'dropdown_item',
                'position-relative',
                item.name === selectedItem.name ? 'selected' : undefined,
                index === highlightedIndex ? 'highlighted' : undefined
              )}
              data-key={`${item.name || ''}-${index}`}
              key={`${item.name || ''}-${index}`}
              {...getItemProps({ item, index })}
            >
              <a {...className('link', 'stretched-link')} href={item.url}>
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      }
    </span>
  );
};

DropdownShareClass.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string
    })
  ),
  selectedItem: PropTypes.shape({
    name: PropTypes.string
  })
};

DropdownShareClass.defaultProps = {
  items: [],
  selectedItem: {}
};

export default DropdownShareClass;
